import React from "react";
import { Link, useLocation } from "react-router-dom";

const MyHeader = () => {
  const location = useLocation();

  return (
    <div className="header">
      <div className="headerLinks">
        {location.pathname !== "/" && (
          <Link className="footerLink" to="/">
            Home
          </Link>
        )}
        {location.pathname !== "/imprint" && (
          <Link className="footerLink" to="/imprint">
            Imprint
          </Link>
        )}
        {location.pathname !== "/privacy" && (
          <Link className="footerLink" to="/privacy">
            Privacy
          </Link>
        )}
      </div>
      <div className="copyrightNotice">
        © {new Date().getFullYear()} Marlene Riedl. All rights reserved.
      </div>
    </div>
  );
};

export default MyHeader;
